module.exports = __webpack_public_path__ + "assets/img/avatar-6.7af53a1e.jpg";